import { createReducer } from 'modules/app-core/redux-utils'
import t from './actionTypes'
import { Location } from './actions'

interface LocationsState {
  [key: string]:
    | Location[]
    | {
        [postalCode: string]: string
      }
  pendingRestorations: {
    [postalCode: string]: string
  }
}

interface LoadLocationsAction {
  type: typeof t.LOAD_LOCATIONS
  payload: {
    locations: Location[]
    postalCode: string
  }
}

interface ResetLocationsAction {
  type: typeof t.RESET_LOCATIONS
  payload: {
    postalCode: string
  }
}

interface RestoreSelectionAction {
  type: typeof t.RESTORE_SELECTION
  payload: {
    postalCode: string
    county: string
  }
}

interface ClearPendingRestorationAction {
  type: typeof t.CLEAR_PENDING_RESTORATION
  payload: {
    postalCode: string
  }
}

type _LocationsAction =
  | LoadLocationsAction
  | ResetLocationsAction
  | RestoreSelectionAction
  | ClearPendingRestorationAction

const initialState: LocationsState = {
  pendingRestorations: {},
} as LocationsState

export default createReducer(initialState, {
  [t.LOAD_LOCATIONS]: (
    state: LocationsState,
    { locations, postalCode }: LoadLocationsAction['payload']
  ) => ({
    ...state,
    [postalCode]: locations,
  }),
  [t.RESET_LOCATIONS]: (
    state: LocationsState,
    { postalCode }: ResetLocationsAction['payload']
  ) => {
    const newState = { ...state }
    delete newState[postalCode]
    return newState
  },
  [t.RESTORE_SELECTION]: (
    state: LocationsState,
    { postalCode, county }: RestoreSelectionAction['payload']
  ) => ({
    ...state,
    pendingRestorations: {
      ...(state.pendingRestorations || {}),
      [postalCode]: county,
    },
  }),
  [t.CLEAR_PENDING_RESTORATION]: (
    state: LocationsState,
    { postalCode }: ClearPendingRestorationAction['payload']
  ) => {
    const newState = { ...state }
    if (newState.pendingRestorations) {
      delete newState.pendingRestorations[postalCode]
    }
    return newState
  },
})
